import { NodeContainer } from '@/GraphEditor/drawingLayer/nodeComposition/NodeContainer';
import { NodeBackground } from '@/GraphEditor/drawingLayer/nodeComposition/NodeBackground';
import { InherentInPort, InherentOutPort } from './Ports';
import { FormTriggerContentLayout } from './FormTriggerContentLayout';
import { useCurrentNode } from '@/GraphEditor/drawingLayer/contexts/CurrentNodeContext';
import { useNodeState } from '@/GraphEditor/drawingLayer/contexts/NodeStateContext';
import type { NodeInstance } from '@glueapp/graph-types';

interface Props {
    nodeInstance: NodeInstance;
}

export const FormTriggerLayout: React.FC<Props> = ({ nodeInstance }) => {
    const node = useCurrentNode();
    const setNodeState = useNodeState();

    return (
        <NodeContainer ariaLabel={node.name}>
            <NodeBackground color={node.color}>
                <FormTriggerContentLayout
                    name={node.name}
                    nodeInstance={nodeInstance}
                    nodeState={nodeInstance.state || {}}
                    setNodeState={setNodeState}
                    renderInherentInPort={() => <InherentInPort />}
                    renderInherentOutPort={() => <InherentOutPort />}
                />
            </NodeBackground>
        </NodeContainer>
    );
};
